<template>
  <div class="container">
    <header>
      <div class="logo">天枢科技（广州）有限公司</div>
      <nav>
        <i class="fa fa-search"></i>
        <a href="#home">首页</a>
        <a href="#jianjie">简介</a>
        <a href="#service">理念</a>
        <a href="#lianxi">联系我们</a>
      </nav>
      <div class="burger">
        <div class="burger-line1"></div>
        <div class="burger-line2"></div>
        <div class="burger-line3"></div>
      </div>
    </header>
    <el-carousel
      id="home"
      indicator-position="outside"
      height="100vh"
      class="carousel"
      ref="carousel"
      @change="carouselChange(activeIndex)"
    >
      <el-carousel-item class="carousel_slide">
        <!-- <div class="carousel-caption">
          <h1>用创新点缀人生，让科技融入理想。</h1>
          <h3>
            科技创新大平台，智慧生活新引擎。依靠科技进步推进经济跨域式发展。用创新点缀人生，让科技融入理想。
          </h3>
          <button class="explore-btn">探索更多</button>
        </div> -->
        <!--遮罩层-->
        <div class="backdrop"></div>
        <img src="../assets/images/banner2.png" />
      </el-carousel-item>
      <el-carousel-item class="carousel_slide">
        <!-- <div class="carousel-caption left">
          <h1>科技改变世界</h1>
          <h3>
            立足科学发展，着力自主创新。加速科技进步，为全市经济社会发展提供有力支撑。凝聚科技创意，成就创新梦想。
          </h3>
          <button class="explore-btn">探索更多</button>
        </div> -->
        <!--遮罩层-->
        <div class="backdrop"></div>
        <!--muted静音 loop循环-->
        <img src="../assets/images/banner1.png" />
        <!-- <video
          src="../assets/videos/working-man.mp4"
          muted
          autoplay
          loop
        ></video> -->
      </el-carousel-item>
    </el-carousel>
    <section class="jianjie" id="jianjie">
      <h3>公司简介</h3>
      <h4>Company profile</h4>
      <div class="box">
        <img src="../assets/images/img1.png" />
        <div class="left">
          <p>
            天枢科技（广州）有限公司成立于2019年01月30日。天枢科技（广州）有限公司
            的宗旨是：以严谨、严谨、细致的工作态度成为一流的互联网公司。主要产品：软件开发;广告业;游戏软件设计制作;网络技术的研究、开发;计算机技术开发、技术服务;信息技术咨询服务;信息电子技术服务;科技信息咨询服务;市场营销策划服务;移动电信业务代理服务;市场调研服务;

          </p>
        </div>
      </div>
    </section>
    <section class="jianjie" id="service">
      <h3>我们的理念</h3>
      <h4>Our services</h4>
      <div class="box">
        <div class="left">
          <p>
            从精准服务开始，成为互联网行业的领导者！
          </p>
        </div>
        <img src="../assets/images/1.png" />
      </div>
    </section>
    <div class="contactus linian" id="lianxi">
      <h3>联系我们</h3>
      <h4>Contact us</h4>
      <div class="text">
         <p class="p1">
           版权所有：天枢科技（广州）有限公司：主营业务：软件开发;广告业;游戏软件设计制作;网络技术的研究、开发;计算机技术开发、技术服务;信息技术咨询服务;信息电子技术服务;科技信息咨询服务;市场营销策划服务;移动电信业务代理服务;市场调研服务;

         </p>
        <p class="p2">联系我们 tianshukeji@tianshukeji.link</p>

      </div>
    </div>
    <!-- <div class="content-wrapper" style="background-color: #fff">
      <section id="about-us" class="about-us">
        <h2 class="title1">关于我们</h2>
        <p class="intro">{{ introduction }}</p>
        <div class="features">
          <div class="feature" v-for="(item, index) in features" :key="index">
            <i :class="item.icon"></i>
            <h4 class="feature-title">{{ item.title }}</h4>
            <p class="feature-content">{{ item.content }}</p>
          </div>
        </div>
      </section>
      <section class="data-section">
        <div class="data-piece" v-for="(item, index) in datas" :key="index">
          <i :class="item.icon"></i>
          <div class="num">{{ item.num }}</div>
          <div class="data-desc">{{ item.desc }}</div>
        </div>
      </section>
    </div> -->
  </div>
</template>

<script>
  import anime from "animejs/lib/anime.es";
  import Isotope from "../assets/lib/isotope/isotope.pkgd.min";
  import SmoothScroll from "../assets/lib/smooth-scroll/smooth-scroll.polyfills.min";

  import { header } from "./Home/index";

  export default {
    name: "Home",
    data() {
      return {
        Index: 0,
        introduction:
          "作为一家以软件技术为核心的公司,通过开放式创新、卓越质量管理、人力资源发展、以客户为中心的组织和服务网络建设等战略实施。",
        serviceIntro:
          "网络综合公司，提供包括网络基础服务(如域名、主机、邮箱)和网络增值服务(如网站建设和推广，网站优化)等业务",
        features: [
          {
            icon: "fa fa-lightbulb-o",
            title: "品牌创意",
            content: "为企业设计独特的并能完美呈现企业价值观的视觉",
          },

          {
            icon: "fa fa-line-chart",
            title: "整合营销",
            content: "通过市场进入分析、制定网络营销战略、网络营销实施",
          },
          {
            icon: "fa fa-shopping-cart",
            title: "电子商务",
            content: "根据企业需求，开设不同的销售渠道，通过网上直销",
          },
          {
            icon: "fa fa-desktop",
            title: "网页设计",
            content: "通过网站建设、只能建站、域名主机、企业邮箱",
          },
          {
            icon: "fa fa-tachometer",
            title: "网站优化",
            content: "网站推广是使将网站推广到国内各大知名网站和搜索引擎",
          },
          {
            icon: "fa fa-server",
            title: "网页架设",
            content: "通过绑定域名和服务器，把网站展现给全世界",
          },
        ],
        datas: [
          {
            icon: "fa fa-code",
            num: 156,
            desc: "行代码",
          },
          {
            icon: "fa fa-money",
            num: 288,
            desc: "个奖项",
          },
          {
            icon: "fa fa-eye",
            num: 1588,
            desc: "位客户",
          },
          {
            icon: "fa fa-folder",
            num: 200,
            desc: "个项目",
          },
        ],
      };
    },
    computed: {
      activeIndex() {
        return this.$refs.carousel.activeIndex;
      },
    },
    /*在模板渲染成html前调用，即通常初始化某些属性值，然后再渲染成视图*/
    created() {
      document.querySelectorAll(".carousel-caption > *").forEach((el) => {
        el.style.opacity = 0;
      });
    },
    /*在模板渲染成html后调用，在初始化界面完成后，再对html的dom节点进行一些需要的操作*/
    mounted() {
      this.$nextTick(function () {
        this.carouselChange(this.Index);
        this.initIsotope();
        header();
        this.initSmoothScroll();
      });
    },

    methods: {
      carouselChange: function (activeIndex) {
        const captionsEl = document.querySelectorAll(".carousel-caption");
        const caption = captionsEl[activeIndex];
        anime({
          targets: caption.children,
          opacity: [0, 1],
          duration: 800,
          easing: "linear",
          delay: anime.stagger(400, { start: 300 }),
          translationY: [anime.stagger([40, 10]), 0],
        });
      },
      initIsotope() {
        const isotope = new Isotope(".cases", {
          layoutMode: "fitRows",
          itemSelector: ".case-item",
        });
        // const filterBtns = document.querySelector(".filter-btns");
        // filterBtns.addEventListener("click", (e) => {
        //   //target为点击的item
        //   let { target } = e;
        //   console.log(target);
        //   const filterOption = target.getAttribute("data-filter");
        //   if (filterOption) {
        //     document
        //       .querySelectorAll(".filter-btn.active")
        //       .forEach((btn) => btn.classList.remove("active"));
        //     target.classList.add("active");
        //     isotope.arrange({ filter: filterOption });
        //   }
        // });
      },
      initSmoothScroll() {
        const scroll = new SmoothScroll(
          'nav a[href*="#"], .scroll-to-top a[href*="#"]',
          {
            /*是否有固定导航*/
            header: "header",
            /*当滚动到区域时的偏移量*/
            offset: 80,
          }
        );
        /* const headerEL=document.querySelector('header');
                                                                                                                                                                                                                                                                                                                                                                                                                                                      document.addEventListener('scrollStart',()=>{
                                                                                                                                                                                                                                                                                                                                                                                                                                                          alert('click')
                                                                                                                                                                                                                                                                                                                                                                                                                                                          if(headerEL.classList.contains('open')){
                                                                                                                                                                                                                                                                                                                                                                                                                                                              headerEL.classList.remove('open');
                                                                                                                                                                                                                                                                                                                                                                                                                                                          }
                                                                                                                                                                                                                                                                                                                                                                                                                                                      });*/
      },
    },
  };
</script>

<style scoped>
  @import "../assets/style/style.css";
</style>
